
define('text!modules/targeting/digital/templates/panel_layout.html',[],function () { return '<div class=\'column-A\'>\n\t<div class=\'list-c\'>\n\t\t<div class="filters-c"></div>\n\t\t<div class="w-body digital-list list-body">\n\t\t\t<div class=\'browser-c\'></div>\n\t\t\t<div class=\'search-c\'></div>\n\t\t</div>\n\t</div>\n</div>\n\n<div class=\'bins-column\'></div>\n';});

